import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import CreatorHarnessNavigation from "../widgets/creatorHarnessNavigation";
import CreatorOrganizations from "../widgets/creatorOrganizations";

const CreatorPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Omniscia Health" />
      <PortalGridContent>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <CreatorOrganizations />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <CreatorHarnessNavigation />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatorPortal));
